import { useEffect } from 'react';
import { listenTrips } from '../../channels/tripsChannel';
import { useTripFiltersStore } from '../../stores/useTripFiltersStore';

export function useTripsFiltersChannel() {

    useEffect(() => {

        const unsubscribe = listenTrips(({ tipo, payload }) => {

            const {
                setSituacoesSelecionadas,
                setDesempenhosSelecionados
            } = useTripFiltersStore.getState();

            if (tipo === 'situacoes-upsert') {

                setSituacoesSelecionadas(payload, false);

            }

            if (tipo === 'desempenhos-upsert') {

                setDesempenhosSelecionados(payload, false);

            }

        });

        return unsubscribe;

    }, []);

}